export default [
  {
    prop: 'final_price',
    label: '返现金额',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'mch_price',
    label: '商户号充值金额',
    minWidth: 150,
    tooltip: true
  },
  {
    prop: 'rate',
    label: '服务费率',
    minWidth: 120,
    tooltip: true
  },
  {
    prop: 'service_price',
    label: '服务费',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'month',
    label: '返现月份',
    minWidth: 100,
    tooltip: true
  },
  {
    prop: 'create_time',
    label: '返现时间',
    minWidth: 180,
    tooltip: true
  },
  {
    prop: 'cashback_status',
    label: '状态',
    minWidth: 110
  },
  {
    prop: 'action',
    label: '操作',
    width: 100
  }
]
